import { gql } from '@apollo/client';

export const SAVE_APP_SETTINGS_MUTATION = gql`
  mutation saveAppSettings($input: SaveAppSettingsInput!) {
    saveAppSettings(input: $input) {
      id
      settingsTab
      settingsJson
      createdAt
      updatedAt
    }
  }
`;
